export default __webpack_public_path__ + "static/media/vendify_logo.38ace167.svg";